import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { SLIPPAGE_CONFIG } from "#/config/slippage";
const defaultValue = SLIPPAGE_CONFIG.options.lowDelta.values[1];

export const lowDeltaSlippagePercentageAtom = atomWithStorage<number>(
  "lowDeltaSlippage",
  defaultValue,
);

export const useLowDeltaSlippagePercentage = () => {
  const [lowDeltaSlippagePercentage, setLowDeltaSlippagePercentage] = useAtom(
    lowDeltaSlippagePercentageAtom,
  );

  const lowDeltaSlippageFactor = Number(
    (lowDeltaSlippagePercentage / 100).toFixed(2),
  );
  return {
    lowDeltaSlippagePercentage,
    lowDeltaSlippageFactor,
    setLowDeltaSlippagePercentage,
  };
};
